<template>
  <router-view />
</template>

<script setup lang="ts">
  import { onMounted } from "vue";
  import { useUserStore } from "@/store/modules/user";
  import { useGlobalTheme } from "@/composables/useTheme";

  const userStore = useUserStore();
  // 初始化全局主题实例，确保暗黑模式默认生效
  useGlobalTheme();

  onMounted(() => {
    // 初始化时从 localStorage 恢复 token
    const token = localStorage.getItem("token");
    if (token) {
      userStore.setToken(token);
      // 可以在这里获取用户信息
    }
  });
</script>
